import { disableLogError } from '@zg-rentals/log-error';
import { INVOICE_PAYMENTS, USER_MANAGEMENT_APPLICATION_PERMISSION_PAGE, USER_MANAGEMENT_PAGE } from '../constants';

import { useRentalManagerUser, useRmwPaths } from '../hooks';

export type PermissionCheckProps = {
  route: string;
  children: JSX.Element | Array<JSX.Element>;
};

export const PermissionCheck = ({ route, children }: PermissionCheckProps): JSX.Element => {
  const { user } = useRentalManagerUser();
  const paths = useRmwPaths();

  const redirectTo: Record<string, string> = {
    [INVOICE_PAYMENTS]: !user.features.canAccessInvoicePayments && paths.propertiesPage,
    [USER_MANAGEMENT_PAGE]: !user.features.canAccessUserManagement && paths.propertiesPage,
    [USER_MANAGEMENT_APPLICATION_PERMISSION_PAGE]:
      !user.features.canAccessUserManagementApplicationPermission && paths.propertiesPage,
  };

  const targetRoute = redirectTo[route];
  if (targetRoute) {
    try {
      disableLogError();
      window.stop();
    } catch (exception) {
      document.execCommand('Stop');
    }
    window.location.href = targetRoute;
  }

  return <>{children}</>;
};
